import { Injectable } from '@angular/core';
import { v4 as guid } from 'uuid';
import { ManualTransactionRequest, SyncEvent, SyncVendor } from '../models';

export interface TransactionRequestGroup {
  request: ManualTransactionRequest;
  activityCount: number;
}

@Injectable()
export class TransactionPreparationService {
  prepareTransactionRequests(activities: SyncEvent[], vendor: SyncVendor): TransactionRequestGroup[] {
    const requests: TransactionRequestGroup[] = [];

    // If vendor is already Email, no need to split
    if (vendor === SyncVendor.Email) {
      const request = this.createTransactionRequest(activities, vendor);
      requests.push({ request, activityCount: activities.length });
      return requests;
    }

    // Split activities based on calendar name containing "Email"
    const emailActivities = activities.filter(a => this.isEmailCalendar(a));
    const nonEmailActivities = activities.filter(a => !this.isEmailCalendar(a));

    // Create request for email activities with Email vendor
    if (emailActivities.length > 0) {
      const request = this.createTransactionRequest(emailActivities, SyncVendor.Email);
      requests.push({ request, activityCount: emailActivities.length });
    }

    // Create request for non-email activities with original vendor
    if (nonEmailActivities.length > 0) {
      const request = this.createTransactionRequest(nonEmailActivities, vendor);
      requests.push({ request, activityCount: nonEmailActivities.length });
    }

    return requests;
  }

  private isEmailCalendar(activity: SyncEvent): boolean {
    const vendorType = activity.vendorType;
    return vendorType == SyncVendor.Email;
  }

  private createTransactionRequest(activities: SyncEvent[], vendor: SyncVendor): ManualTransactionRequest {
    return {
      transactionId: guid(),
      vendorType: vendor,
      manualTransactionItems: activities.map(a => ({
        activityId: a.activityId,
        eventId: a.eventId,
        eventName: a.eventName,
        calendar: a.calendar,
        status: a.syncStatus
      }))
    } as ManualTransactionRequest;
  }
}
